/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_Resume_PendingInputs */

const en_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set up yet -- you can add one from the dashboard`)
};

const de_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht eingerichtet -- du kannst einen vom Dashboard aus hinzufügen`)
};

const fr_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non configuré pour l'instant -- tu peux en ajouter un depuis le tableau de bord`)
};

const es_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No configurado aún -- puede agregar uno desde el panel`)
};

const it_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ancora configurato -- puoi aggiungerne uno dal dashboard`)
};

const nl_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niet ingesteld -- je kunt er een toevoegen vanaf het dashboard`)
};

const pl_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ustawione jeszcze -- możesz dodać je z pulpitu nawigacyjnego`)
};

const fi_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä asetettu -- voit lisätä sen hallintapaneelista`)
};

const da_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke sat op endnu — du kan tilføje et fra dashboardet`)
};

const sv_onboarding_complete_resume_pending = /** @type {(inputs: Onboarding_Complete_Resume_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte inställt ännu -- du kan lägga till en från instrumentpanelen`)
};

/**
* | output |
* | --- |
* | "Not set up yet -- you can add one from the dashboard" |
*
* @param {Onboarding_Complete_Resume_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_resume_pending = /** @type {((inputs?: Onboarding_Complete_Resume_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_Resume_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_resume_pending(inputs)
	if (locale === "fr") return fr_onboarding_complete_resume_pending(inputs)
	if (locale === "es") return es_onboarding_complete_resume_pending(inputs)
	if (locale === "it") return it_onboarding_complete_resume_pending(inputs)
	if (locale === "nl") return nl_onboarding_complete_resume_pending(inputs)
	if (locale === "pl") return pl_onboarding_complete_resume_pending(inputs)
	if (locale === "fi") return fi_onboarding_complete_resume_pending(inputs)
	if (locale === "da") return da_onboarding_complete_resume_pending(inputs)
	if (locale === "sv") return sv_onboarding_complete_resume_pending(inputs)
	return en_onboarding_complete_resume_pending(inputs)
});